import { render } from "./AddPayGrade.vue?vue&type=template&id=7b85c7ad"
import script from "./AddPayGrade.vue?vue&type=script&lang=js"
export * from "./AddPayGrade.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__